import myHealth from '@web/containers/MyHealth/localization'
import _ from 'lodash'

const localization = {
  en: {
    allergy: '',
    dateIdentified: 'Date identified',
    reactions: 'Reactions'
  },
  es: {
    allergy: '',
    dateIdentified: 'Fecha en que se identificó',
    reactions: 'Reacciones',
    loadMore: 'Cargar más'
  },
  keyMapping: {
    allergy: '',
    dateIdentified: 'UFD_Date_Identified_Text',
    reactions: 'UFD_Reactions_Text'
  }
}

export default _.merge(myHealth, localization)
